import { useCallback, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { seperationActions } from "../../store/SeperationSlice/index";
import {
  downloadBulkSeperationTemplate,
  getAllSeperationReportees,
  getSeperatonRequestList,
  revokeSeperation,
  submitSeperation,
  summaryView,
  uploadFileWithPresignedUrl,
} from "../../store/SeperationSlice/thunk";
import {
  voluntaryReasons,
  involuntaryReasons,
} from "../../constants/seperation";
import CommonModal from "../../commonComponents/CommonModal";
import SeperationSummary from "../../components/SeperationSummary";
import EmployeeCard from "../../components/EmployeeCard";
import SeperationRequestList from "../../components/SeperationRequestList";
import SeparationForm from "../../components/SeparationForm";
import ChangeLwdForm from "../../components/ChangeLwdForm";
import HomeIcon from "../../assets/images/resigned-cardboard-box-1 2.png";
import BtnIcon from "../../assets/icons/move_item.svg";
import DeleteIcon from "../../assets/icons/delete.svg";
import NoteIcon from "../../assets/icons/note_add.svg";
import SubmitIcon from "../../assets/icons/inventory.svg";
import RevokeIcon from "../../assets/icons/tab_close_right.svg";
import BackIcon from "../../assets/icons/arrow_back.svg";
import DownloadIcon from "../../assets/icons/download.svg";
import DocImg from "../../assets/images/xlsx_img.jpg";
import moment from "moment";
import * as XLSX from "xlsx";
import Lottie from "react-lottie";
import successAnimationData from "../../assets/animations/success.json";
import failAnimationData from "../../assets/animations/failure.json";
import "./Separation.css";

const Separation = () => {
  const employeeID = useSelector((state) => state.auth.employeeID);

  const [seperationFlow, setSeperationFlow] = useState("create");
  const [employeeFormData, setEmployeeFormData] = useState({
    employee_id: employeeID,
  });
  const [seprationUserType, setSeprationUserType] = useState("");
  const [bulkFile, setBulkFile] = useState();
  const [formDataErr, setFormDataErr] = useState(false);
  const [dateOfResignErr, setDateOfResignErr] = useState(false);
  const [fileUploadErr, setFileUploadErr] = useState(false);
  const [allEmployees, setAllEmployees] = useState([]);
  const [hasMore, setHasMore] = useState(true);
  const [offset, setOffset] = useState(0);
  const LIMIT = 18;
  const openModalRef = useRef();
  const closeModalRef = useRef();
  const openRevokeModalRef = useRef();
  const closeRevokeModalRef = useRef();
  const openLwdModalRef = useRef();
  const closeLwdModalRef = useRef();
  const openTemplateModalRef = useRef();
  const closeTemplateModalRef = useRef();
  const openSuccessModalRef = useRef();
  const closeSuccessModalRef = useRef();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const mandatoryFields = [
    "employee_id",
    "resignation_date",
    "req_last_date",
    "recovery_days",
    "final_sepration_type",
    "reason",
    "reason_comments",
  ];

  const fileRef = useRef();
  const observerRef = useRef();

  const allReportees = useSelector(
    (state) => state.seperation.allReportees?.reportees || [],
  );
  const allReporteesStatus = useSelector(
    (state) => state.seperation.allReporteesStatus || [],
  );
  const seperationRequestList = useSelector(
    (state) => state.seperation.seperationRequestList?.data || [],
  );
  const role = useSelector(
    (state) => state?.auth?.loginResponse?.body?.role_type || "",
  );
  const isSeparationManager = useSelector(
    (state) => state?.auth?.loginResponse?.body?.separation_manager || "",
  );
  const submitSeperationResponseStatus = useSelector(
    (state) => state.seperation.submitSeperationResponseStatus || "",
  );
  const revokeSeperationResponseStatus = useSelector(
    (state) => state.seperation.revokeSeperationResponseStatus || "",
  );
  const changeLwdResponseStatus = useSelector(
    (state) => state.seperation.changeLwdResponseStatus || "",
  );
  // const fileUploadResponseStatus = useSelector(
  //   (state) => state.seperation.fileUploadResponseStatus || ""
  // );
  // const fileUploadResponse = useSelector(
  //   (state) => state.seperation.fileUploadResponse || ""
  // );
  const summaryViewResponse = useSelector(
    (state) => state.seperation.summaryViewResponse || "",
  );
  const employeeSelected = useSelector(
    (state) => state.seperation.employeeSelected || "",
  );
  const downloadBulkSeperationResponse = useSelector(
    (state) => state.seperation.downloadBulkSeperationResponse || "",
  );
  const downloadBulkSeperationResponseStatus = useSelector(
    (state) => state.seperation.downloadBulkSeperationResponseStatus || "",
  );
  const bulkEmployeeList = useSelector(
    (state) => state.seperation.bulkEmployeeList || [],
  );
  const noticePeriod = useSelector(
    (state) => state.seperation.noticePeriodResponse?.data,
  );

  const defaultOptions = {
    loop: true, // Set to true for infinite looping
    autoplay: true, // Automatically start the animation
    animationData: bulkEmployeeList?.length
      ? successAnimationData
      : failAnimationData, // JSON animation data
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice", // Adjust aspect ratio
    },
  };

  useEffect(() => {
    dispatch(
      getSeperatonRequestList({
        employee_id: employeeID,
        is_by_l1: role !== "USER" ? true : false,
      }),
    );
    // Reset the separation flow and createSeperate state when the component mounts
    return () => {
      setSeperationFlow("create");
      dispatch(seperationActions.setInitialState());
      setAllEmployees([]);
      dispatch(seperationActions.resetDownloadBulkSeperationResponse());
    };
  }, []);

  useEffect(() => {
    if (employeeFormData?.resignation_date && employeeFormData?.req_last_date) {
      setDateOfResignErr(false);
      const resignationDate = moment(employeeFormData?.resignation_date);
      const requestedLastDate = moment(employeeFormData?.req_last_date);

      if (resignationDate.isAfter(requestedLastDate)) {
        setDateOfResignErr(true);
        setEmployeeFormData((prevData) => ({
          ...prevData,
          req_last_date: "",
        }));
        return;
      }
      const differenceInDays = moment(
        moment(resignationDate).add(noticePeriod, "days"),
      ).diff(requestedLastDate, "days");

      // Update recovery_days in employeeFormData
      setEmployeeFormData((prevData) => ({
        ...prevData,
        recovery_days: Math.max(differenceInDays, 0),
      }));
    } else {
      setEmployeeFormData((prevData) => ({ ...prevData, recovery_days: 0 }));
    }
  }, [employeeFormData?.resignation_date, employeeFormData?.req_last_date]);

  useEffect(() => {
    if (employeeSelected) {
      setEmployeeFormData({
        ...employeeFormData,
        employee_id: employeeSelected.employee_id,
      });
    }
  }, [employeeSelected]);

  useEffect(() => {
    if (seperationFlow === "create") {
      dispatch(seperationActions.clearAllreportees());
      dispatch(
        getSeperatonRequestList({
          employee_id: employeeID,
          is_by_l1: role !== "USER" ? true : false,
        }),
      );
      dispatch(seperationActions.setIsReporteeSeperation(false));
      dispatch(seperationActions.setEmployeeSelected(null));
      setAllEmployees([]);
      setEmployeeFormData({
        employee_id: employeeID,
      });
      setFormDataErr(false);
    }
    // if (seperationFlow === "reportee") {
    //   dispatch(getAllSeperationReportees({ offset: 0, limit: 18 }));
    // }
    if (seperationFlow === "summary") {
      dispatch(seperationActions.setEmployeeSelected(null));
      dispatch(
        summaryView({
          employee_id: employeeSelected
            ? employeeSelected?.employee_id
            : employeeID,
        }),
      );
    }
  }, [seperationFlow, dispatch]);

  useEffect(() => {
    if (!bulkFile) {
      fileRef.current.value = "";
    }
  }, [bulkFile]);

  useEffect(() => {
    if (allReporteesStatus === "SUCCESS" && allReportees) {
      if (allReportees.length > 0) {
        if (offset === 0) {
          // First page
          setAllEmployees(allReportees);
        } else {
          // Append new employees using functional update to avoid dependency on allEmployees
          setAllEmployees((prev) => {
            const existingIds = new Set(prev.map((emp) => emp.employee_id));
            const newEmployees = allReportees.filter(
              (emp) => !existingIds.has(emp.employee_id),
            );
            return [...prev, ...newEmployees];
          });
        }
        setHasMore(allReportees.length >= LIMIT);
      } else {
        if (offset === 0) {
          setAllEmployees([]);
        }
        setHasMore(false);
      }
    }
  }, [allReportees, allReporteesStatus, offset]);

  const loadMoreEmployees = useCallback(() => {
    if (allReporteesStatus === "PENDING" || !hasMore) return;

    const newOffset = offset + LIMIT;
    setOffset(newOffset);
    dispatch(
      getAllSeperationReportees({
        offset: offset,
        limit: LIMIT,
        separation_manager: isSeparationManager,
      }),
    );
  }, [dispatch, offset, allReporteesStatus, hasMore]);

  // api responses
  const lastEmployeeElementRef = useCallback(
    (node) => {
      if (allReporteesStatus === "PENDING") return;

      if (observerRef.current) {
        observerRef.current.disconnect();
      }

      observerRef.current = new IntersectionObserver(
        (entries) => {
          if (entries[0].isIntersecting && hasMore) {
            loadMoreEmployees();
          }
        },
        { threshold: 0.1 },
      );

      if (node) {
        observerRef.current.observe(node);
      }
    },
    [allReporteesStatus, hasMore, loadMoreEmployees],
  );

  useEffect(() => {
    if (submitSeperationResponseStatus === "SUCCESS") {
      setSeperationFlow("summary");
      onCloseModal();
    }
    if (submitSeperationResponseStatus === "ERROR") {
      onCloseModal();
    }
  }, [submitSeperationResponseStatus, dispatch, employeeID, employeeSelected]);

  useEffect(() => {
    if (revokeSeperationResponseStatus === "SUCCESS") {
      setSeperationFlow("create");
      closeRevokeModalRef.current.click();
    }
  }, [revokeSeperationResponseStatus]);

  useEffect(() => {
    // After a last-working-day change, close the modal and reload the summary so
    // the new date, recovery days and change history show immediately.
    if (changeLwdResponseStatus === "SUCCESS") {
      closeLwdModalRef.current?.click();
      const empId = summaryViewResponse?.data?.employee_id || employeeID;
      dispatch(seperationActions.resetChangeLwdResponse());
      dispatch(summaryView({ employee_id: empId }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [changeLwdResponseStatus]);

  // useEffect(() => {
  //   if (fileUploadResponseStatus === "SUCCESS") {
  //     setEmployeeFormData({
  //       ...employeeFormData,
  //       attachments: fileUploadResponse?.presignedUrlResponse?.fields?.key,
  //     });
  //   }
  // }, [fileUploadResponseStatus]);

  useEffect(() => {
    if (downloadBulkSeperationResponseStatus === "SUCCESS") {
      window.open(downloadBulkSeperationResponse?.body);
      dispatch(seperationActions.resetDownloadBulkSeperationResponse());
    }
  }, [downloadBulkSeperationResponseStatus]);

  // handlers
  const changeFlow = () => {
    if (seperationFlow === "create") {
      if (role !== "USER" && isSeparationManager) {
        setSeperationFlow("reporteeSelect");
      } else {
        setSeperationFlow("form");
      }
      setAllEmployees([]);
      setEmployeeFormData({
        employee_id: employeeID,
      });
      setFormDataErr(false);
    } else {
      dispatch(seperationActions.setIsReporteeSeperation(false));
      dispatch(seperationActions.clearAllreportees());
      setSeprationUserType("");
      setSeperationFlow("create");
      setEmployeeFormData({
        employee_id: employeeID,
      });
    }
  };

  const onSelectSeperationUserType = (type) => {
    setSeprationUserType(type);
    if (type === "yourself") {
      setSeperationFlow("form");
    } else {
      dispatch(
        getAllSeperationReportees({
          offset: offset,
          limit: LIMIT,
          separation_manager: isSeparationManager,
        }),
      );
    }
  };

  const onCloseModal = () => {
    closeModalRef.current.click();
  };

  const onCloseTemplateModal = () => {
    if (fileRef.current) {
      fileRef.current.value = "";
    }
    closeSuccessModalRef.current.click();
  };

  const onSelectEmployee = (item) => {
    dispatch(seperationActions.setIsReporteeSeperation(true));
    dispatch(seperationActions.setEmployeeSelected(item));
    setSeperationFlow("form");
  };

  const onUpdateEmployeeFormData = ({ key, value }) => {
    console.log("key, value", key, value);
    if (key === "resignation_date") {
      setEmployeeFormData({
        ...employeeFormData,
        final_date_of_exit: value
          ? moment(value).add(noticePeriod, "days").format("YYYY-MM-DD")
          : "",
        req_last_date: value
          ? moment(value).add(noticePeriod, "days").format("YYYY-MM-DD")
          : "",
        [key]: value,
      });
    } else if (key === "file") {
      dispatch(
        uploadFileWithPresignedUrl({
          employee_id: employeeSelected
            ? employeeSelected?.employee_id
            : employeeID,
          file: value,
          key: "seperation",
        }),
      );
      setEmployeeFormData({
        ...employeeFormData,
        [key]: value,
      });
    } else if (key === "final_sepration_type") {
      setEmployeeFormData({
        ...employeeFormData,
        [key]: value,
        reason: "",
      });
    } else {
      setEmployeeFormData({
        ...employeeFormData,
        [key]: value,
      });
    }
  };

  const validateFormdata = () => {
    setFormDataErr(false);
    // setFileMandatoryErr(false);
    // setShowValidationError(false);
    let checkAllKeysExist = mandatoryFields.every(
      (key) =>
        employeeFormData[key] !== undefined &&
        employeeFormData[key] !== null &&
        employeeFormData[key] !== "",
    );

    // Check if attachment is provided when recovery_days > 0
    // if (employeeFormData?.recovery_days > 0 && !employeeFormData?.attachments) {
    //   setFileMandatoryErr(true);
    //   setShowValidationError(true);
    //   return;
    // }

    if (!checkAllKeysExist) {
      setFormDataErr(true);
    } else {
      openModalRef.current.click();
    }
  };

  const onSelectSepertationCard = (item) => {
    dispatch(seperationActions.setEmployeeSelected(item));
    setSeperationFlow("summary");
  };

  const readUploadFile = (e) => {
    setBulkFile(e.target.files[0]);
    setFileUploadErr(false);
    e.preventDefault();
    if (!e.target.files || e.target.files.length === 0) return;

    const file = e.target.files[0];
    const fileName = file.name.toLowerCase();

    // Validate file type
    if (!fileName.endsWith(".xlsx")) {
      setFileUploadErr(true);
      fileRef.current.value = "";
      return;
    }

    const reader = new FileReader();

    reader.onload = (e) => {
      const data = e.target.result;
      const workbook = XLSX.read(data, { type: "array" });
      const sheetName = workbook.SheetNames[0];
      const worksheet = workbook.Sheets[sheetName];
      const json = XLSX.utils.sheet_to_json(worksheet, { raw: false });

      // Process the data
      const formattedData = formatData(json);
      const updatedListWithRecoveryDays = calculateRecoveryDays(formattedData);
      const validatedData = validateSeparationData(updatedListWithRecoveryDays);

      // Dispatch the validated data
      if (validatedData.length) {
        dispatch(seperationActions.setBulkEmployeeList(validatedData));
      }
    };

    reader.readAsArrayBuffer(file);
  };

  const formatData = (json) => {
    // Convert date fields from decimal to proper date format
    return json.map((row) => {
      const formattedRow = { ...row };
      Object.keys(formattedRow).forEach((key) => {
        if (
          !isNaN(formattedRow[key]) &&
          typeof formattedRow[key] === "number"
        ) {
          const parsedDate = XLSX.SSF.parse_date_code(formattedRow[key]);
          if (parsedDate) {
            formattedRow[key] = new Date(
              parsedDate.y,
              parsedDate.m - 1,
              parsedDate.d,
            ).toISOString();
          }
        }
      });
      return formattedRow;
    });
  };

  const calculateRecoveryDays = (data) => {
    return data.map((item) => {
      if (item?.resignation_date && item?.req_last_date) {
        const resignationDate = moment(item?.resignation_date);
        const requestedLastDate = moment(item?.req_last_date);
        const differenceInDays = requestedLastDate.diff(
          resignationDate,
          "days",
        );
        return {
          ...item,
          recovery_days: differenceInDays,
        };
      }
      return item;
    });
  };

  const validateSeparationData = (data) => {
    return data.map((item) => {
      if (item?.final_sepration_type && item?.reason) {
        const checkReasonExist =
          item.final_sepration_type === "Voluntary"
            ? voluntaryReasons.includes(item?.reason)
            : item.final_sepration_type === "Involuntary"
              ? involuntaryReasons.includes(item?.reason)
              : item.final_sepration_type === "Death"
                ? ["Death"].includes(item?.reason)
                : item.final_sepration_type === "Retirement"
                  ? ["Retirement"].includes(item?.reason)
                  : false;

        return checkReasonExist
          ? item
          : {
              ...item,
              reason: "",
            };
      }
      return item;
    });
  };

  // api calls
  const onSubmitEmployeeSeperation = () => {
    setFormDataErr(false);
    const formDataToSubmit = {
      ...employeeFormData,
      is_by_l1: false,
      bulk: false,
    };
    if (
      role !== "USER" &&
      employeeSelected &&
      employeeSelected?.employee_id !== employeeID
    ) {
      formDataToSubmit.is_by_l1 = true;
      formDataToSubmit.approver = employeeID;
    }
    delete formDataToSubmit.file;
    delete formDataToSubmit.submit_check;
    dispatch(submitSeperation(formDataToSubmit));
  };

  const onRevokeSeperation = () => {
    dispatch(
      revokeSeperation({
        employee_id: employeeSelected
          ? employeeSelected?.employee_id
          : employeeID,
      }),
    );
  };

  const onDownloadTemplate = () => {
    dispatch(
      downloadBulkSeperationTemplate({
        key: "jedi-bucket/separation_template.xlsx",
      }),
    );
  };

  // modals
  const SeperationConfirm = () => (
    <div className="sp-confir">
      <div className="sp-cf-head">separation confirmation</div>
      <div className="sp-cf-subhead">
        Before Proceeding, please ensure you have checked all the details
        carefully.
      </div>
      <div className="sp-cf-content">
        <div className="sp-cf-label">Date of Resignation</div>
        <div className="sp-cf-value">
          {moment(employeeFormData?.resignation_date).format("DD MMMM YYYY")}
        </div>
      </div>
      <div className="sp-cf-content">
        <div className="sp-cf-label">LWD as per Notice Period</div>
        <div className="sp-cf-value">
          {moment(employeeFormData?.final_date_of_exit).format("DD MMMM YYYY")}(
          {noticePeriod} Days)
        </div>
      </div>
      <div className="sp-cf-content">
        <div className="sp-cf-label">Requested LWD</div>
        <div className="sp-cf-value">
          {moment(employeeFormData?.req_last_date).format("DD MMMM YYYY")}
        </div>
      </div>
      {(employeeFormData?.recovery_days && (
        <div className="valid-text">
          You have requested for an early release. Please note recovery days as
          per policy will get deducted from full and final settlement
        </div>
      )) ||
        ""}
      <div className="sp-cf-btns">
        <button
          className="sp-cf-submit"
          onClick={() => {
            onSubmitEmployeeSeperation();
          }}
        >
          Submit
        </button>
        <button className="sp-cf-dismiss" onClick={() => onCloseModal()}>
          Dismiss
        </button>
      </div>
    </div>
  );

  const CreateFromTemplateModal = () => (
    <div className="flex flex-col">
      <div className="cfr-subtext">
        Upload file with all required fileds completed to create employees
        individually or in bulk.
      </div>

      {bulkFile ? (
        <>
          <div className="dc-main-box mt-2 postion-relative">
            <div className="flex justify-between w-full p-12 mb-auto">
              <div className="flex items-center ml-auto">
                <div className="dc-card-ico-wrap">
                  <img src={DownloadIcon} className="dc-card-ico" alt="" />
                </div>
                <div className="dc-card-ico-wrap">
                  <img
                    src={DeleteIcon}
                    className="dc-card-ico"
                    alt="delete"
                    onClick={() => {
                      setBulkFile();
                      setFileUploadErr(false);
                    }}
                  />
                </div>
              </div>
            </div>
            <img className="dc-file-preview" src={DocImg} alt="doc" />
            <div className="flex dc-card-nameplate mt-auto w-full p-12">
              <div className="mr-auto dc-card-filename">{bulkFile?.name}</div>
            </div>
            {/* <img
              className="dc-card-ico"
              src={CloseIcon}
              alt=""
              onClick={() => {
                setBulkFile();
                setFileUploadErr(false);
              }}
              style={{
                height: "25px",
                width: "25px",
                padding: "2px",
                cursor: "pointer",
                backgroundColor: "red",
                borderRadius: "50%",
                position: "absolute",
                top: "-15px",
                right: "-6px",
              }}
            /> */}
          </div>
        </>
      ) : (
        <>
          <div className="cfr-btn flex justify-between">
            <div className="cfr-btn-text">Download template file</div>
            <div
              className="cfr-ico-wrap"
              onClick={() => {
                onDownloadTemplate();
              }}
            >
              <img className="cfr-btn-img" src={DownloadIcon} alt="" />
            </div>
          </div>
          <div className="flex cfr-upload">
            <div className="cfr-upload-text">
              Drag and drop here or browse to upload
            </div>
            <input
              type="file"
              className="cfr-upload-input"
              // accept=".xlsx"
              onChange={(e) => {
                readUploadFile(e);
              }}
              ref={fileRef}
            />
          </div>
        </>
      )}
      {fileUploadErr && (
        <div className="valid-text">
          Please upload a valid file format(.xlsx)
        </div>
      )}
      <button
        className="btn p-btn p-btn-og justify-center mt-3"
        onClick={() => openSuccessModalRef.current.click()}
        disabled={!bulkFile || fileUploadErr}
      >
        <div className="p-btn-text">Import List</div>
      </button>
    </div>
  );

  const CreateFromTemplateSuccessModal = () => (
    <div className="flex flex-col">
      <div className="flex justify-center">
        {/* <img className="cfts-img" src={SuccessIcon} alt="" /> */}
        <div className="animation-container">
          <Lottie options={defaultOptions} height={300} width={300} />
        </div>
      </div>
      <div className="cfts-text">
        {bulkEmployeeList?.length
          ? bulkEmployeeList?.length +
            " Employees Profile Imported Successfully."
          : "No Employee Profiles details found."}
      </div>
      {(bulkEmployeeList?.length && (
        <button
          className="btn p-btn p-btn-og justify-center"
          onClick={() => {
            onCloseTemplateModal();
            navigate("./list");
          }}
        >
          <div className="p-btn-text">View Details</div>
        </button>
      )) ||
        ""}
    </div>
  );

  const RevokeSeperationConfirm = ({ data }) => (
    <div className="sp-confir">
      {/* <div className="sp-cf-head">Revoke confirmation</div> */}
      <div className="sp-cf-subhead">
        are you sure you want to revoke this separation?
      </div>
      <div className="sp-cf-content">
        <div className="sp-cf-label">Date of Resignation</div>
        <div className="sp-cf-value">
          {moment(data?.date_of_resignation).format("DD MMMM YYYY")}
        </div>
      </div>
      <div className="sp-cf-content">
        <div className="sp-cf-label">LWD as per Notice Period</div>
        <div className="sp-cf-value">
          {moment(data?.final_date_of_exit).format("DD MMMM YYYY")} (
          {noticePeriod} Days)
        </div>
      </div>
      <div className="sp-cf-content">
        <div className="sp-cf-label">Requested LWD</div>
        <div className="sp-cf-value">
          {moment(data?.req_date_of_exit).format("DD MMMM YYYY")}
        </div>
      </div>
      <div className="sp-cf-btns">
        <button
          className="sp-cf-submit"
          onClick={() => {
            onRevokeSeperation();
          }}
        >
          Revoke Separation
        </button>
        <button
          className="sp-cf-dismiss"
          onClick={() => closeRevokeModalRef.current.click()}
        >
          Dismiss
        </button>
      </div>
    </div>
  );

  return (
    <div className="sp-home">
      <div className="flex justify-between w-full">
        <div
          className={`flex items-center ${
            !seperationRequestList?.length && "w-full"
          }`}
        >
          {seperationFlow === "create" && (
            <button
              type="button"
              aria-label="Back to all modules"
              className="xl:hidden mr-3 flex h-12 w-12 shrink-0 items-center justify-center rounded-full bg-slate-100 border-0"
              onClick={() => navigate("../all")}
            >
              <img src={BackIcon} alt="Back" className="h-5 w-5" />
            </button>
          )}
          {seperationFlow !== "create" && (
            <img
              src={BackIcon}
              alt="icon"
              className="rq-home-btn-ico mr-2"
              onClick={() => changeFlow()}
            />
          )}
          <div className="sp-head font-semibold">
            {seperationFlow !== "create"
              ? seperationFlow === "summary"
                ? "separation summary"
                : "initiate separation"
              : "separation"}
          </div>
          {role === "HR" &&
            seperationFlow === "create" &&
            !seperationRequestList?.length && (
              <div
                className="btn btn-sp-template ml-auto"
                onClick={() => openTemplateModalRef.current.click()}
              >
                {/* <img className="p-btn-icon" src={NoteIcon} alt="" /> */}
                <span
                  class="material-symbols-outlined"
                  style={{ color: "black" }}
                >
                  note_add
                </span>
                <div className="sp-btn-text">Add From Template</div>
              </div>
            )}
        </div>
        {(seperationFlow === "create" && seperationRequestList?.length && (
          <div className="flex">
            {role === "HR" && (
              <div className="flex">
                <div
                  className="btn btn-sp-template"
                  onClick={() => openTemplateModalRef.current.click()}
                >
                  {/* <img className="p-btn-icon" src={NoteIcon} alt="" /> */}
                  <span
                    class="material-symbols-outlined"
                    style={{ color: "black" }}
                  >
                    note_add
                  </span>
                  <div className="sp-btn-text">Add From Template</div>
                </div>
              </div>
            )}
            <div
              className="btn btn-sp-initiate ml-3"
              onClick={() => changeFlow()}
            >
              {/* <img className="p-btn-icon" src={BtnIcon} alt="" /> */}
              <span
                class="material-symbols-outlined"
                style={{ color: "white" }}
              >
                move_item
              </span>
              <div className="in-btn-text">Initiate Separation</div>
            </div>
          </div>
        )) ||
          ""}
        {/* {seperationFlow === "reporteeSelect" && role === "HR" && ( */}

        {seperationFlow === "form" && (
          <div className="flex">
            <button
              className="btn p-btn p-btn-og separation-submit-button"
              onClick={() => validateFormdata()}
              disabled={
                (employeeFormData?.employee_id === employeeID &&
                  !employeeFormData?.submit_check) ||
                !employeeFormData?.employee_id
              }
            >
              <img className="p-btn-icon" src={SubmitIcon} alt="" />
              <div className="p-btn-text">Submit</div>
            </button>
            <button
              className="btn p-btn p-btn-og separation-sm-submit-button"
              onClick={() => validateFormdata()}
              disabled={
                (employeeFormData?.employee_id === employeeID &&
                  !employeeFormData?.submit_check) ||
                !employeeFormData?.employee_id
              }
            >
              <span
                class="material-symbols-outlined"
                style={{ color: "white" }}
              >
                inventory
              </span>
            </button>
          </div>
        )}
        {seperationFlow === "summary" && (
          <div className="flex">
            {(summaryViewResponse?.data?.can_change_lwd && (
              <button
                className="btn p-btn p-btn-og"
                onClick={() => {
                  dispatch(seperationActions.resetChangeLwdResponse());
                  openLwdModalRef.current.click();
                }}
              >
                <span
                  className="material-symbols-outlined"
                  style={{ color: "white" }}
                >
                  edit_calendar
                </span>
                <div className="p-btn-text">Change Last Working Day</div>
              </button>
            )) ||
              ""}
            {(summaryViewResponse?.data?.status === "Pending" && (
              <button
                className="btn p-btn p-btn-og2"
                onClick={() => openRevokeModalRef.current.click()}
              >
                <img className="p-btn-icon" src={RevokeIcon} alt="" />
                <div className="p-btn-text">Revoke Separation</div>
              </button>
            )) ||
              ""}
          </div>
        )}
      </div>

      {seperationFlow === "create" ? (
        <>
          {seperationRequestList.length ? (
            <SeperationRequestList
              data={seperationRequestList}
              onSelect={onSelectSepertationCard}
            />
          ) : (
            <div className="sp-create sm:h-full h-1/2">
              <img className="sp-home-ico" src={HomeIcon} alt="" />
              <div className="sp-home-text">
                Click on the Initiate Separation button below to start the
                process!
              </div>
              <button
                className="btn sp-home-btn"
                onClick={() => {
                  changeFlow();
                }}
              >
                <img src={BtnIcon} alt="" className="sp-home-btn-ico" />
                <div className="sp-home-btn-text">Initiate Separation</div>
              </button>
            </div>
          )}
        </>
      ) : seperationFlow === "reporteeSelect" ? (
        <>
          <div className="flex w-full sp-select">
            <div className="sp-reportee-subhead">
              Initiate the separation process for
            </div>
            <div className="sp-reportee-list flex ml-auto">
              <button
                className="sp-reportee-item sp-select-btn mr-3"
                style={{
                  border: seprationUserType === "yourself" && "2px solid black",
                }}
                onClick={() => onSelectSeperationUserType("yourself")}
              >
                Yourself
              </button>
              <button
                className="sp-reportee-item sp-select-btn"
                style={{
                  border: seprationUserType === "reportee" && "2px solid black",
                }}
                onClick={() => onSelectSeperationUserType("reportee")}
              >
                Your Reportee
              </button>
            </div>
          </div>
          {/* ) : seperationFlow === "reportee" ? ( */}
          <div className="card-container">
            {allEmployees?.length > 0 && (
              <div className="rq-cards">
                {allEmployees?.map((item, index) => {
                  const isLastElement = allEmployees.length === index + 1;
                  return (
                    <div
                      key={`${item.employee_id}-${index}`}
                      ref={isLastElement ? lastEmployeeElementRef : null}
                    >
                      <EmployeeCard
                        page={"request"}
                        isExpanded={false}
                        data={item}
                        onSelectEmployee={() => {
                          onSelectEmployee(item);
                        }}
                        userDetails={employeeSelected}
                      />
                    </div>
                  );
                })}
              </div>
            )}
          </div>
        </>
      ) : seperationFlow === "form" ? (
        <SeparationForm
          onUpdate={onUpdateEmployeeFormData}
          formData={employeeFormData}
          isError={formDataErr}
          changeFlow={changeFlow}
          isValidationError={dateOfResignErr}
          // fileMandatoryErr={fileMandatoryErr}
          confirmationRequired={
            isSeparationManager && employeeID !== employeeFormData?.employee_id
              ? false
              : true
          }
        />
      ) : seperationFlow === "summary" ? (
        <SeperationSummary
          data={summaryViewResponse?.data}
          employeeID={employeeID}
        />
      ) : (
        <></>
      )}

      <CommonModal
        openRef={openModalRef}
        closeRef={closeModalRef}
        id={"separationConfirmModal"}
        hideCloseButton={false}
        content={<SeperationConfirm />}
        disabled={false}
        size={"md"}
      />
      <CommonModal
        openRef={openRevokeModalRef}
        closeRef={closeRevokeModalRef}
        id={"revokeSeparationConfirmModal"}
        hideCloseButton={false}
        content={
          <RevokeSeperationConfirm data={summaryViewResponse?.data || []} />
        }
        disabled={false}
        size={"md"}
      />
      <CommonModal
        openRef={openLwdModalRef}
        closeRef={closeLwdModalRef}
        id={"changeLwdModal"}
        hideCloseButton={false}
        content={
          <ChangeLwdForm
            key={`${summaryViewResponse?.data?.employee_id}-${summaryViewResponse?.data?.lwd_current}-${summaryViewResponse?.data?.lwd_changes?.length}`}
            data={summaryViewResponse?.data || {}}
            onDismiss={() => closeLwdModalRef.current.click()}
          />
        }
        disabled={false}
        size={"md"}
      />
      <CommonModal
        openRef={openTemplateModalRef}
        closeRef={closeTemplateModalRef}
        id={"CreateFromTemplateModal"}
        modalHeadText={"add from template"}
        hideCloseButton={false}
        content={<CreateFromTemplateModal />}
        disabled={false}
        size={"md"}
        onModalClose={() => {
          // closeTemplateModalRef.current.click();
          setBulkFile();
          if (fileRef.current) {
            fileRef.current.value = "";
          }
        }}
        headerTextAlign="left"
        headerSpacing={"pb-0"}
      />
      <CommonModal
        openRef={openSuccessModalRef}
        closeRef={closeSuccessModalRef}
        id={"CreateFromTemplateSuccessModal"}
        modalHeadText={"add from template"}
        hideCloseButton={true}
        content={<CreateFromTemplateSuccessModal />}
        disabled={false}
        size={"md"}
        onModalClose={() => {
          setBulkFile();
          if (fileRef.current) {
            fileRef.current.value = "";
          }
        }}
        outSideCloseButton={true}
      />
    </div>
  );
};
export default Separation;
